export default __webpack_public_path__ + "src/images/packages/bundox-safari-lodge/fd8e57d05096fa0156391dae1da20e3d-2.jpg";